import { useParams, useNavigate, Link } from "react-router-dom";
import { isoData } from "../pages/servicesData.js";
import { FaArrowLeft, FaCheckCircle, FaArrowRight, FaClock, FaAward, FaBookOpen } from "react-icons/fa";
import "../Style/ServiceDetail.css";

function ServiceDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const data = isoData[id];

  if (!data) {
    return (
      <div className="container error-page">
        <h2>Standard Not Found</h2>
        <p>The requested ISO certification details page path does not exist.</p>
        <button className="primary-btn" onClick={() => navigate("/")}>Return Home</button>
      </div>
    );
  }

  const CustomIcon = data.icon;

  return (
    <div className="service-detail-page reveal-fade-in">
      {/* Banner / Hero Segment */}
      <div className="detail-hero" style={{ backgroundImage: `linear-gradient(rgba(11, 21, 40, 0.75), rgba(11, 21, 40, 0.85)), url(${data.heroImage})` }}>
        <div className="container hero-content">
          <Link to="/" className="back-link">
            <FaArrowLeft /> Back to Dashboard
          </Link>
          <div className="hero-badge">
            <CustomIcon /> <span>{data.subtitle}</span>
          </div>
          <h1>{data.title}</h1>
        </div>
      </div>

      {/* Main Core Breakdown Content */}
      <div className="container detail-body">
        <div className="detail-main-content">
          
          {/* Overview Block with Modern Secondary Context Image Split */}
          <section className="detail-section-block split-intro">
            <div className="intro-text-panel">
              <span className="mini-accent-tag">CORE STATEMENT</span>
              <h3>Strategic Importance</h3>
              <p className="summary-text">{data.summary}</p>
            </div>
            <div className="intro-image-panel">
              <img 
                src={data.heroImage} 
                alt={`${data.title} workspace deployment`} 
                className="context-inset-img"
              />
              <div className="image-depth-card">
                <FaAward /> Verified Standard
              </div>
            </div>
          </section>

          {/* Core Business Benefits Grid Grid Panel Section */}
          <section className="detail-section-block">
            <span className="mini-accent-tag">ADVANTAGES</span>
            <h3>Core Business Benefits</h3>
            <div className="benefits-grid">
              {data.benefits.map((benefit, idx) => (
                <div key={idx} className="benefit-item-card">
                  <div className="icon-wrap-green">
                    <FaCheckCircle className="benefit-icon" />
                  </div>
                  <p>{benefit}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Implementation Roadmap Interactive Timeline Elements */}
          <section className="detail-section-block">
            <span className="mini-accent-tag">ROADMAP</span>
            <h3>Implementation Journey</h3>
            <div className="detail-process-timeline">
              {data.process.map((step, idx) => (
                <div key={idx} className="timeline-step">
                  <div className="step-num-badge">{idx + 1}</div>
                  <div className="step-content-box">
                    <div className="step-inner-flex">
                      <FaClock className="step-time-icon" />
                      <p>{step}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>

        {/* Floating Contextual Conversion Sidebar Directory */}
        <aside className="detail-sidebar">
          <div className="sidebar-card contact-card animate-glow">
            <div className="sidebar-header-icon-wrap">
              <FaBookOpen />
            </div>
            <h4>Ready to Begin Certification?</h4>
            <p>Get a step-by-step implementation timeline customized for your company size.</p>
            <button className="primary-btn w-full">Request Free Consultation</button>
          </div>

          <div className="sidebar-card quick-links-card">
            <h4>Other Standards</h4>
            <div className="quick-links-list">
              {Object.keys(isoData).map((key) => (
                key !== id && (
                  <Link key={key} to={`/services/${key}`} className="sidebar-lnk">
                    <span>{key.toUpperCase().replace("-", " ")}</span>
                    <FaArrowRight />
                  </Link>
                )
              ))}
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
}

export default ServiceDetail;